import { useEffect, useState } from "react";
import { RefreshCw, CheckCircle2, AlertTriangle } from "lucide-react";
import { runningBuildId, deployedBuildId, forceUpdateNow } from "@/serviceWorkerRegistration";

// Tells a station which build it is actually running, and lets a human force the
// update. Updates are already automatic; this exists so "is this device stale?"
// is answerable at a glance instead of guessed at.
export default function BuildInfo({ compact = false }) {
  const running = runningBuildId();
  const [deployed, setDeployed] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    deployedBuildId().then((d) => { if (!cancelled) setDeployed(d); });
    return () => { cancelled = true; };
  }, []);

  const stale = deployed && running !== "dev" && deployed !== running;

  const update = async () => {
    setBusy(true);
    await forceUpdateNow();
  };

  return (
    <div className={compact ? "text-[11px]" : "text-xs"} data-testid="build-info">
      <div className="flex items-center gap-1.5 text-slate-500">
        {stale ? (
          <AlertTriangle size={12} className="text-amber-600 shrink-0" />
        ) : deployed ? (
          <CheckCircle2 size={12} className="text-emerald-600 shrink-0" />
        ) : null}
        <span className="mono truncate">
          Build {running}
          {stale ? ` → ${deployed} available` : deployed ? " (latest)" : ""}
        </span>
      </div>

      <button
        type="button"
        onClick={update}
        disabled={busy}
        className={
          "mt-1.5 inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md border transition disabled:opacity-50 " +
          (stale
            ? "bg-amber-600 border-amber-600 text-white hover:bg-amber-700"
            : "border-slate-300 text-slate-600 hover:bg-slate-100")
        }
        data-testid="btn-force-update"
      >
        <RefreshCw size={12} className={busy ? "animate-spin" : ""} />
        {busy ? "Updating…" : stale ? "Update now" : "Check for updates"}
      </button>
    </div>
  );
}
